import { MarkIcon, CloseIcon, EditIcon } from "assets";

import "./settings-content-list.scss";
import { Button } from "shared";
export const SettingsContentList = ({
  items,
  itemTitle,
  onDelete,
  onEdit,
  hasDelete,
  firstItem,
  deleteMessage,
  isBtnLoading,
  isEditBtnLoading,
  isEditable
}) => {
  const confirmDelete = (id) => {
    if (window.confirm(deleteMessage)) {
      onDelete(id);
    }
  };

  return (
    <div className="list-info">
      <div className="list-info__title">{itemTitle}</div>

      <ul className="list-info__list">
        {items.map((item) => (
          <li className="list-info__list-item" key={item.id}>
            <span className="list-info__name">{item.name}</span>
            {item.name === firstItem && <MarkIcon className="list-info__vector" />}
            <div className="button-section">
              {isEditable && (
                <Button
                  buttonIcon={<EditIcon className="list-info__delete-icon" />}
                  event={() => onEdit(item)}
                  spinnerColor={"dark"}
                  isLoading={isEditBtnLoading}
                />
              )}
              {hasDelete && (
                <Button
                  buttonIcon={<CloseIcon className="list-info__delete-icon" />}
                  event={() => confirmDelete(item.id)}
                  spinnerColor={"dark"}
                  isLoading={isBtnLoading}
                />
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SettingsContentList;
